import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    const isOpen = !this.contentTarget.classList.contains("hidden")
    this.contentTarget.classList.toggle("hidden")
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-chevron-right", isOpen)
      this.iconTarget.classList.toggle("fa-chevron-down", !isOpen)
    }
  }
}
